<template>
    <b-container fluid  class="max-width">
        <div>
            <h2 class="text-primary pt-4" v-if="currentUserId === userId">{{ trans('profile.edit.my_profile') }}</h2>
            <h2 class="text-primary pt-4" v-else>{{userInfo.displayName}}</h2>
            <hr />
            <!-- <b-col class="py-1 px-0 profile-sidebar-option col d-flex justify-content-end" v-if="currentUserId !== userId">
                <b-button variant="secondary" :href="`mailto:${email}`" v-if="userInfo.displayName !== undefined">
                    {{trans('community.profile-other.write_to', {fullname: userInfo.displayName})}}
                </b-button>
            </b-col> -->
            <div class="mb-5" />
        </div>
        <div class="px-lg-5" v-if="!isLoading">
            <div class="px-lg-5 pb-5">
                <b-row>
                    <div class="col-md-4">
                        <profile-photo
                            :isCurrentUser="false"
                            :userAvatar="userAvatar"
                            :userInfo="userInfo"
                        />
                        <h4 class="text-center">{{userInfo.displayName}}</h4>
                        <div class="d-flex flex-row justify-content-center">
                            <profile-counter v-for="(counter, c) in counters"
                                :key="`counter-${c}`"
                                :count="counter.count"
                                :label="counter.label"
                            />
                        </div>
                    </div>

                    <div class="col-md-8 justify-content-center">
                        <other-user-profile-posts />
                    </div>
                </b-row>
            </div>
        </div>
        <div v-else class="w-100 d-flex justify-content-center">
            <b-spinner class="align-middle" variant="secondary" />
        </div>
    </b-container>
</template>

<script>
    import ProfileSidebar from "../../organisms/ProfileSidebar"
    import ProfilePhoto from "../../molecules/ProfilePhoto"
    import OtherUserProfilePosts from "./OtherUserProfilePosts"
    import ProfileCounter from "../../atoms/ProfileCounter"
    import { mapGetters, mapActions } from "vuex";

    export default {
        name: "ProfilePublicContainer",
        components: { ProfileCounter, OtherUserProfilePosts, ProfileSidebar, ProfilePhoto },
        data() {
            return {
                isLoading: true,
                userAvatar: null,
                userInfo: {},
                counters: [],
                userId: null,
            }
        },
        mounted(){
            trackEvent("ProfileDashboardView", {})
            this.userId = this.$route.params.id;
            this.getUserInfo();
        },
        computed: {
            ...mapGetters({
                getCurrentUserId: 'user/getUserId',
            }),
            currentUserId: function () {
                return this.getCurrentUserId.toString()
            },
        },
        methods:{
            getUserInfo(){
                this.$axios.get(`/api/rest/profile/info/${this.userId}`)
                    .then((response)=>{
                        this.isLoading = false;
                        this.userInfo = response.data.userInfo;
                        this.counters = response.data.counters;
                        this.userAvatar = response.data.userInfo.avatarUrl;
                    })
                    .catch((e)=>{
                        console.log(e);
                    })
            },
        }
    }
</script>
